import ExecutionDetailsCard from "~/components/build/Show/pages/summary/ExecutionDetailsCard";
import BuildContextCard from "~/components/build/Show/pages/summary/TriggerSourceCard";

export default function Overview() {
  return (
    <div className="flex flex-wrap gap-3 sm:gap-4">
      <div className="min-w-[240px] max-w-[600px] flex-1">
        <BuildContextCard />
      </div>

      <div className="h-full min-w-[240px] max-w-[600px] flex-1">
        <ExecutionDetailsCard />
      </div>
    </div>
  );
}
